import { isFeatureFlagEnabled } from '@doordash/lib-feature-flags'
import { CheckrStatusResults } from '../../../../../../constants'
import { DX_CRO_BGC_NCC_LINK_GRADUATION } from '../../../../../../experimentConstants'

export function isBackgroundCheckExternalLinkStep(application, options) {
  const { isAtCapacity } = options
  const { dasherId, dateOfBirth, backgroundCheckResults } = application
  const hasDasher = !!dasherId
  const hasDob = !!dateOfBirth

  return (
    isFeatureFlagEnabled(DX_CRO_BGC_NCC_LINK_GRADUATION) &&
    hasDasher &&
    hasDob &&
    !isAtCapacity &&
    backgroundCheckResults === CheckrStatusResults.Skipped
  )
}
